export default "__VITE_ASSET__DsDUOskS__"